import useAsyncData from "../../../hooks/use-async-data";
import driverService from "../driver.service";
import DriverPotentialPlan from "./driver-potential-plan";
import DriverPotentialPlanParams from "./driver-potential-plan-params";

const useDriverPotentialPlan = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<DriverPotentialPlan>({ entries: [] });

  const load = async (
    params: DriverPotentialPlanParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverPotentialPlan =
        await driverService.getDriverRoutePlansAfterCandidatureApproval(
          params,
          signal,
        );

      setData(driverPotentialPlan);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDriverPotentialPlan;
